import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * usePatrimonioCentroCustoListaFilter
 */

type State = {
  status: number;
  idsCentroCusto: number[];
};

export const initialPatrimonioCentroCustoLista: State = {
  status: 0,
  idsCentroCusto: [],
};

export const usePatrimonioCentroCustoListaFilter = create<State>((set) => ({
  ...initialPatrimonioCentroCustoLista,
}));